// Copiato da https://github.com/react-bootstrap/react-overlays/blob/v1.2.0/src/utils/getContainer.js
import ReactDOM from 'react-dom'

export default function getContainer(container, defaultContainer) {
  if (container == null) return defaultContainer

  container = typeof container === 'function' ? container() : container
  return ReactDOM.findDOMNode(container) || null
}